import React from "react";
import { useLang } from "@/i18n";

const FLAG = {
  nl: "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/orqlhgjc_flag%20NL.jpg",
  es: "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/irgtrcfv_FLAG%20ESP.jpg",
  en: "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/qyheamco_flag%20uk.jpg",
};

const OPTIONS = [
  { code: "nl", label: "Nederlands" },
  { code: "es", label: "Español" },
  { code: "en", label: "English" },
];

const FlagButton = ({ code, label, active, onClick }) => (
  <button
    type="button"
    data-testid={`lang-flag-${code}`}
    onClick={onClick}
    aria-label={label}
    aria-pressed={active}
    title={label}
    className="group relative rounded-2xl overflow-hidden border-2 transition-all duration-200 hover:-translate-y-0.5 active:scale-[0.97]"
    style={{
      width: 52,
      height: 52,
      borderColor: active ? "#FFFFFF" : "rgba(255,255,255,0.5)",
      backgroundColor: "rgba(0,0,0,0.32)",
      boxShadow: active
        ? "0 8px 22px rgba(0,0,0,0.45), 0 0 0 3px rgba(255,255,255,0.55), inset 0 2px 6px rgba(255,255,255,0.35), inset 0 -4px 10px rgba(0,0,0,0.30)"
        : "0 6px 16px rgba(0,0,0,0.35), inset 0 2px 6px rgba(255,255,255,0.30), inset 0 -4px 10px rgba(0,0,0,0.28)",
    }}
  >
    <img
      src={FLAG[code]}
      alt={label}
      draggable={false}
      className={`w-full h-full object-cover transition-all duration-200 ${
        active ? "grayscale-0" : "grayscale group-hover:grayscale-0"
      }`}
    />
  </button>
);

// 3 square flags under the logo: Dutch, Spanish, English.
export const FlagSwitcher = () => {
  const { lang, setLang } = useLang();
  return (
    <div className="flex items-center justify-center gap-3" data-testid="lang-flag-switcher">
      {OPTIONS.map((o) => (
        <FlagButton
          key={o.code}
          code={o.code}
          label={o.label}
          active={lang === o.code}
          onClick={() => setLang(o.code)}
        />
      ))}
    </div>
  );
};

export default FlagSwitcher;
